/* eslint-disable perfectionist/sort-imports */
import { Box } from '@mui/material';
import 'src/global.css';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';

// Import Component ที่สร้างใหม่ (ตรวจสอบ path ให้ถูกต้อง)
import CookieConsent from './sections/CookieConsent/CookieConsent'; 
import TechnicianServiceWrapper from './components/TechnicianServiceWrapper'; 

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <ThemeProvider>
      <TechnicianServiceWrapper>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Router />

          {/* เรียกใช้ Component ตรงนี้ จบเลย ง่ายมาก */}
          <CookieConsent />
          
        </Box>
      </TechnicianServiceWrapper>
    </ThemeProvider>
  );
}